import React, { useRef, useState } from "react";
import styled from "styled-components";
import { Button, Calendar, Col, Row, Select } from 'antd';
import 'moment/locale/zh-cn';
import moment from 'moment';
import zh_CN from 'antd/es/date-picker/locale/zh_CN';
import { FontStyleTypes } from 'design-system-old';
import { hexToRgb, parseWidgetData, uuid2 } from "@byk/utils/Utils";
import dayjs, { type Dayjs } from "dayjs";
moment.locale('zh-cn'); // 设置moment的locale为中文

const defaultConfig: any = {
  monthColor: "black",
  monthFontSize: "1rem",
  monthFontStyle: "BOLD",

  weekColor: "gray",
  weekFontSize: "",
  weekFontStyle: "",

  dateColor: "black",
  dateFontSize: "",
  dateFontStyle: "",

  selectColor: "#2561ef",
  markColor: "#fa746b",
}

const DivContainer = styled.div<{
  monthColor?: string,
  monthFontSize?: string,
  monthFontStyle?: string,

  weekColor?: string,
  weekFontSize?: string,
  weekFontStyle?: string,

  dateColor?: string,
  dateFontSize?: string,
  dateFontStyle?: string,

  selectColor?: string,
  markColor?: string,

  boxShadow?: string,

  borderWidth?: string,
  borderRadius?: string,
  selectColor10?: string,
}>`
    width: 100%;
    height:100%;
    min-width:255px;
    .z-Calendar-main{
      box-shadow: ${({ boxShadow }) => `${boxShadow}`} !important;
      border-width: ${({ borderWidth }) => `${borderWidth}px`} !important;
      border-radius: ${({ borderRadius }) => (borderRadius)};
    }
    .z-Calendar-main .ant-picker-panel{
      border-radius: ${({ borderRadius }) => (`0 0 ${borderRadius} ${borderRadius}`)};
    }
    //月切换字体设置
    .z-Calendar-date{
      font-size:${({ monthFontSize }) => monthFontSize || defaultConfig.monthFontSize}!important;
      color: ${({ monthColor }) => monthColor || defaultConfig.monthColor}!important;
      font-style: ${({ monthFontStyle }) => monthFontStyle?.includes(FontStyleTypes.ITALIC) ? "italic" : ""}  !important;
      font-weight: ${({ monthFontStyle }) => monthFontStyle?.includes(FontStyleTypes.BOLD) ? "BOLD" : ""}  !important;
    }
    //星期字体设置
    .ant-picker-calendar-mini .ant-picker-content th {
      height: auto;
      padding: 0;
      line-height: 22px;
      font-size:${({ weekFontSize }) => weekFontSize || defaultConfig.weekFontSize}!important;
      color: ${({ weekColor }) => weekColor || defaultConfig.weekColor}!important;
      font-style: ${({ weekFontStyle }) => weekFontStyle?.includes(FontStyleTypes.ITALIC) ? "italic" : ""}  !important;
      font-weight: ${({ weekFontStyle }) => weekFontStyle?.includes(FontStyleTypes.BOLD) ? "BOLD" : ""}  !important;
    }
    .ant-picker-cell-inner .ant-picker-calendar-date-value{
      font-size:${({ dateFontSize }) => dateFontSize || defaultConfig.dateFontSize}!important;
      color: ${({ dateColor }) => dateColor || defaultConfig.dateColor};
      font-style: ${({ dateFontStyle }) => dateFontStyle?.includes(FontStyleTypes.ITALIC) ? "italic" : ""}  !important;
      font-weight: ${({ dateFontStyle }) => dateFontStyle?.includes(FontStyleTypes.BOLD) ? "BOLD" : ""}  !important;
    }
    .ant-picker-cell .ant-picker-cell-inner {
      min-width: 30px;
      height: 30px;
      line-height: 30px;
      border-radius: 20px;
    }

    //选中背景色
    .ant-picker-cell-selected .ant-picker-cell-inner1 {
      background:${({ selectColor }) => selectColor || defaultConfig.selectColor};
    }


    .ant-picker-cell .chooseDateClassdateInClass,.ant-picker-cell .chooseDateClassdateNotInClass {
      background:${({ selectColor }) => selectColor || defaultConfig.selectColor}!important;
    }
    .ant-picker-cell .chooseDateClassdateInClass  .ant-picker-calendar-date-value,.ant-picker-cell .chooseDateClassdateNotInClass  .ant-picker-calendar-date-value {
      color:white  ;
    }

    .ant-picker-cell .noChooseDateClassdateInClass {
      background:transparent !important;
    }
    .ant-picker-cell .noChooseDateClassdateInClass  .ant-picker-calendar-date-value {
      color: ${({ dateColor }) => dateColor || defaultConfig.dateColor} !important;
    }
    .noChooseDateClassdateInClass  .ant-picker-calendar-date-value {
      color: ${({ dateColor }) => dateColor || defaultConfig.dateColor} !important;
    }
    .ant-picker-cell .noChooseDateClassdateNotInClass {
      background:transparent !important;
    }
    .ant-picker-cell .noChooseDateClassdateNotInClass  .ant-picker-calendar-date-value {
      color:rgba(0, 0, 0, 0.25)  ;
    }


    .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before{border: none;}
    //提醒色颜色
    .dot-bottom::after {
      content: "";
      display: block;
      width: 4px;
      height: 4px;
      background: ${({ markColor }) => markColor || defaultConfig.markColor}!important;
      border-radius: 50%;
      margin-top: -6px;
      margin-left: 13px;
    }
    .chooseDateClassdateNotInClass  .dot-bottom::after,.chooseDateClassdateInClass  .dot-bottom::after {
      background: white !important; //选中的圆点颜色
    }

    .ant-btn:focus, .ant-btn:hover {
      color: ${({ selectColor }) => selectColor}!important;
      border-color: ${({ selectColor }) => selectColor}!important;
      background: ${({ selectColor10 }) => selectColor10}!important;
    }
`;
const getDateByString=(dateString:any)=>{
  if (!dateString || typeof dateString !== 'string') {
      return moment();
  }
  // 创建 Moment 对象并验证
  const m = moment(dateString);
  return m.isValid()?moment(dateString):moment();
}
function CarouselComponent(props: any) {
  const {
    onSelectedDateChange,
    onMonthChange,
    value,
    monthColor,
    monthFontSize,
    monthFontStyle,

    weekColor,
    weekFontSize,
    weekFontStyle,

    dateColor,
    dateFontSize,
    dateFontStyle,

    selectColor,
    markColor,

    boxShadow,
    borderWidth,
    borderRadius,
    currentData,
    defaultDate,
    chooseDateMoment
  } = props;
  //const defaultValue=
  const [defaultValue, setDefaultValue] = useState(getDateByString(defaultDate));
  const getMappingData = (data: any, keepPrefix = true) => {
    if (Array.isArray(data)) {
      return data.map(item => getMappingData(item, keepPrefix));
    }
    if (data && typeof data === 'object') {
      const result: any = {};
      Object.keys(data).forEach(key => {
        if (key.includes(`${props.widgetName}.mapping`)) {
          if (keepPrefix) {
            result[key] = data[key];
          } else {
            const newKey = key.replace(`${props.widgetName}.mapping.`, '');
            result[newKey] = data[key];
          }
        }
        else {
          result[key] = data[key];
        }
      });
      return result;
    }
    return data;
  }
  const selectColor10 = hexToRgb(selectColor, 0.1);
  const _value = getMappingData(parseWidgetData(value || currentData),false);
  const onItemClick = (date: any) => {
    onSelectedDateChange && onSelectedDateChange(date);
  }
  const valueDateStrings = _value.map((item:any) => {
    return dayjs(item["date"]).format('YYYY-MM-DD')||null;
  });
  const disabledDate = (current: Dayjs) => {
    return current && !valueDateStrings.includes(current.format('YYYY-MM-DD'));
  };
  const timestampToDate=(timestamp:any, format = 'YYYY-MM-DD HH:mm:ss')=> {
    const date = new Date(timestamp);
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return format
        .replace('YYYY', year)
        .replace('MM', month)
        .replace('DD', day)
        .replace('HH', hours)
        .replace('mm', minutes)
        .replace('ss', seconds);
}
  const [fixedDate, setFixedDate] = useState(dayjs());
  return (
    <>
      <DivContainer
        monthColor={monthColor}
        monthFontSize={monthFontSize}
        monthFontStyle={monthFontStyle}

        weekColor={weekColor}
        weekFontSize={weekFontSize}
        weekFontStyle={weekFontStyle}

        dateColor={dateColor}
        dateFontSize={dateFontSize}
        dateFontStyle={dateFontStyle}

        selectColor={selectColor}
        selectColor10={selectColor10}
        markColor={markColor}

        boxShadow={boxShadow}
        borderWidth={borderWidth}
        borderRadius={borderRadius}
      >       
        <Calendar
          fullscreen={false}
          locale={zh_CN}
          className="z-Calendar-main"
          disabledDate={disabledDate}
          onSelect={(date) => {
            onItemClick(date);
          }}  
          dateFullCellRender={(date) => {
            let strDate = date.format('YYYY-MM-DD');
            let len = (Array.isArray(_value)) ? _value.filter((itm: any) => {
              // 将 itm.date 时间戳转换为 YYYY-MM-DD 格式
              let itemDate = dayjs(itm.date).format('YYYY-MM-DD');
              return itemDate == strDate;
            }).length : 0;
            let isChooseDay=false;
            let chooseDate=chooseDateMoment&&timestampToDate(chooseDateMoment,'YYYY-MM-DD');
            if(chooseDate&&chooseDate==strDate){
              isChooseDay=true;
            }
            const getClass=(isChooseDay:boolean,isDateIn:boolean)=>{
              if(isChooseDay&&isDateIn){
                return "chooseDateClassdateInClass"
              }
              else if(!isChooseDay&&isDateIn){
                return "noChooseDateClassdateInClass"
              }
              else if(isChooseDay&&!isDateIn){
                return "chooseDateClassdateNotInClass"
              }
              else if(!isChooseDay&&!isDateIn){
                return "noChooseDateClassdateNotInClass"
              }
            }
            return (
              <>
                <div key={uuid2()} className={`ant-picker-cell-inner ant-picker-calendar-date ${getClass(isChooseDay,len > 0)}`}>
                  <div className={`ant-picker-calendar-date-value ${len > 0 ? "dot-bottom" : ""}`}>
                    {date.date()}
                  </div>
                </div>
              </>
            )
          }}
          headerRender={({ value, type, onChange, onTypeChange }) => {
            const change = (type: number) => {
              let newDate = type == 1 ? value.add(1, 'months') : value.subtract(1, 'months');
              onMonthChange(newDate);
            }

            const changeNow = () => {
              onChange(moment());
            }

            const selectYearMonth = (y: number, m: number) => {
              const newDate =value.set('year', y).set('month', m - 1)
              onMonthChange(newDate);
            }

            const year = value.year();
            const month = value.month() + 1;
            const yearOptions: number[] = [];
            for (let y = 1970; y <= 2100; y++) {
              yearOptions.push(y);
            }
            const monthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

            return (
              <div style={{ padding: 8 }}>
                <Row >
                  <Col span={16} className='z-Calendar-date'>
                    <span style={{ cursor: "pointer" }} onClick={() => change(0)}>{"<"}&nbsp;</span>
                    <Select
                      size={"small"}
                      bordered={false}
                      value={year}
                      onChange={(y: number) => selectYearMonth(y, month)}
                      dropdownMatchSelectWidth={false}
                      getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
                    >
                      {yearOptions.map((y) => (
                        <Select.Option key={y} value={y}>{y}年</Select.Option>
                      ))}
                    </Select>
                    <Select
                      size={"small"}
                      bordered={false}
                      value={month}
                      onChange={(m: number) => selectYearMonth(year, m)}
                      dropdownMatchSelectWidth={false}
                      getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
                    >
                      {monthOptions.map((m) => (
                        <Select.Option key={m} value={m}>{m}月</Select.Option>
                      ))}
                    </Select>
                    <span style={{ cursor: "pointer" }} onClick={() => change(1)}>&nbsp;{">"}</span>
                  </Col>
                  <Col span={8} style={{ textAlign: "right" }}>
                    <Button size={"small"} onClick={()=>changeNow()}>今天</Button>
                  </Col>
                </Row>
              </div>
            );
          }}
        />
      </DivContainer>
    </>
  )
}

export default CarouselComponent;
